'use client';

export const SuccessFilled = ({ className, ...props }: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<path
				d="M16.0026 30C14.0662 30 12.246 29.6326 10.5422 28.8977C8.83839 28.1628 7.35635 27.1655 6.09611 25.9057C4.83586 24.646 3.83805 23.1646 3.10268 21.4615C2.36756 19.7584 2 17.9388 2 16.0026C2 14.0662 2.36744 12.246 3.10232 10.5422C3.83719 8.83839 4.83451 7.35635 6.09426 6.09611C7.35402 4.83586 8.83544 3.83805 10.5385 3.10268C12.2416 2.36756 14.0612 2 15.9974 2C17.9338 2 19.754 2.36744 21.4578 3.10232C23.1616 3.83719 24.6436 4.83451 25.9039 6.09426C27.1641 7.35402 28.1619 8.83544 28.8973 10.5385C29.6324 12.2416 30 14.0612 30 15.9974C30 17.9338 29.6326 19.754 28.8977 21.4578C28.1628 23.1616 27.1655 24.6436 25.9057 25.9039C24.646 27.1641 23.1646 28.1619 21.4615 28.8973C19.7584 29.6324 17.9388 30 16.0026 30Z"
				fill="#339D37"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20.6106 11.4359C20.8984 11.1484 21.26 11 21.6666 11C22.0732 11 22.4349 11.1484 22.7227 11.4359C23.0136 11.7272 23.1588 12.0951 23.1526 12.5062C23.1462 12.9052 23.0062 13.2648 22.7231 13.5483L15.3049 20.9666C14.9764 21.2948 14.5702 21.4743 14.1076 21.4743C13.6451 21.4743 13.2391 21.2949 12.9106 20.9667L9.25142 17.3076C8.96397 17.0198 8.81531 16.658 8.81531 16.2513C8.81531 15.8447 8.96375 15.4831 9.25122 15.1953C9.54251 14.9044 9.91044 14.7592 10.3215 14.7654C10.7205 14.7717 11.0802 14.9117 11.3636 15.1949L14.1077 17.9392L20.6106 11.4359Z"
				fill="white"
			/>
		</svg>
	);
};
